module.exports = __webpack_public_path__ + "static/flash-241c620f049493e7f43b023e38c0527c.jpg";